export enum PropType {
  Numeric = 1,
  String = 2,
  LocalDate = 3,
  DateTime = 4,
  Phone = 5,
  Email = 6,
  Enum = 7,
  Other = -1,
}

export default interface CustomerProp {
  propName?: string;
  fieldName?: string;
  propType: number;
  propTypeName?: string;
  builtIn: boolean;
  enumValue: { [index: string]: number };
}
